const segmentsList = {
  bindings: {
    data: '<',
    filter: '<',
    loading: '<',
    modalOptions: '<',
    onToggle: '&',
    onDelete: '&',
    hasEdit: '<',
    isLocked: '<'
  },
  templateUrl: '/modules/pis-tool/segments/segments-list/segments-list.html',
  controller: 'SegmentsListController',
};

angular
  .module('segments.module')
  .component('segmentsList', segmentsList);
